import { Component, ViewChild, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/debounceTime';

import { AdalService } from './shared/azure-authentication/adal.service';
import { User } from './users/user.model';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    showSidebar = false;
    isMobileView = false;
    navMode = 'push';
    title = 'app';
    @ViewChild('sidenav') sidenav: MatSidenav;

    constructor(private adalService: AdalService) {
        Observable.fromEvent(window, 'resize')
            .debounceTime(200)
            .subscribe(() => {
                this.adjustSidenav();
            });
    }

    ngOnInit(): void {
        this.adjustSidenav();
    }

    private adjustSidenav(): void {
        if (window.innerWidth > 768) {
            this.isMobileView = false;
            this.navMode = 'side';
            this.sidenav.open();
        } else {
            this.navMode = 'push';
            this.isMobileView = true;
            this.sidenav.close();
        }
    }

    toggleSidenav(): void {
        if (this.isMobileView) {
            this.sidenav.opened = !this.sidenav.opened;
        }
    }

    logout() {
        this.adalService.logout();
    }

    public get isLoggedIn() {
        return this.adalService.isAuthenticated;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/app.component.ts